module.exports = __webpack_public_path__ + "img/banner-mobile.6f8f2e59.png";